// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
// Utils
import ReactDOM from 'react-dom';
import { ZIndex } from '../../../common/types/ZIndex';
// Hooks
import { useEscapeKeyboardEvent } from '../hooks/useEscapeKeyboardEvent';
export var ModalBackgroundStructure = function (_a) {
    var children = _a.children, onBackgroundClick = _a.onBackgroundClick, className = _a.className, top = _a.top;
    useEscapeKeyboardEvent(onBackgroundClick);
    return ReactDOM.createPortal(React.createElement(React.Fragment, null,
        React.createElement(Container, { role: 'presentation', className: className, onClick: onBackgroundClick, zIndex: ZIndex.COVER_BLOCK }),
        React.createElement(Container, { position: 'fixed', top: top !== null && top !== void 0 ? top : '50%', left: '50%', zIndex: ZIndex.COVER_BLOCK, transform: "translate(-50%, " + (top ? '0' : '-50%') + ")", width: 'fit-content', height: 'fit-content', boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.24)', borderRadius: '4px' }, children)), document.body);
};
//# sourceMappingURL=ModalBackgroundStructure.js.map